import React from 'react';
import PropTypes from 'prop-types';
import OverlayButton from './OverlayButton';

const propTypes = {
  drafting: PropTypes.bool,
  hide: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  overlayText: PropTypes.string,
};

const defaultProps = {
  drafting: undefined,
  hide: undefined,
  overlayText: undefined,
};

const DraftButton = ({
  drafting, hide, onClick, overlayText,
}) => {
  if (hide) {
    return null;
  }

  return (
    <OverlayButton
      size="sm"
      context="neutral"
      onClick={onClick}
      loading={drafting}
      overlayText={overlayText}
    >
      Make Draft
    </OverlayButton>
  );
};

DraftButton.propTypes = propTypes;
DraftButton.defaultProps = defaultProps;

export default DraftButton;
